import { ContextMenu } from '@consta/uikit/ContextMenu'
import type { ContextMenuElementType } from '@core/core/types'
import { stopPropagation } from 'common/helpers'
import type { FC } from 'react'

import css from './TreeCustomContextMenuc.css'
import type { PropsType } from './types'

export const TreeCustomContextMenu: FC<PropsType> = ({
  items,
  contextMenuRef,
  setIsShowContextMenu,
  getActionFromItem,
  isOpen,
}) => {
  const onHideMenu = () => {
    setIsShowContextMenu(false)
  }

  const onContextClick =
    ({ type, subMenu }: ContextMenuElementType) =>
    () => {
      getActionFromItem(type)

      if (!subMenu?.length) {
        onHideMenu()
      }
    }

  if (!items.length) return null

  return (
    <ContextMenu
      className={css.customMenu}
      isOpen={isOpen}
      size="s"
      direction="downRight"
      subMenuDirection="rightStartUp"
      anchorRef={contextMenuRef}
      items={items}
      getItemLabel={item => item.label}
      getItemSubMenu={({ subMenu }) => subMenu ?? undefined}
      getItemGroupId={item => item.group}
      getItemOnClick={item => onContextClick(item)}
      onClick={stopPropagation}
      onClickOutside={onHideMenu}
    />
  )
}
